export default "__VITE_ASSET__FLHX1R0k__"